export var onClickScrollToTarget = function (target) {
  if (target && target.ref && typeof target.ref.scrollIntoView === 'function') {
    target.ref.scrollIntoView({
      block: 'nearest'
    });
  } else if (target && typeof target.scrollTo !== 'undefined') {
    window.scrollTo(0, target.scrollTo);
  }
};